module.exports = __webpack_public_path__ + "img/nipigeLogo.21cdc026.svg";